import React from 'react';
import PropTypes from 'prop-types';
// import PropTypes from 'prop-types';
import DatePicker from 'material-ui/DatePicker';
import styles from 'styles/components/lib/formElements/dateRange.css';
import { Arrow, ResetBtn } from 'components/lib/buttons/IconButtons';

const DateRange = (props, context) => {
  let { isTouchDevice } = context.media;
  return (
    <div className={styles.row}>
      <DatePicker
        style={{width: '35%'}}
        textFieldStyle={{width:'90%', fontSize: '13px', paddingLeft: '10px'}}
        container={(!isTouchDevice) && "inline"}
        hintText="Start Date"
        value={props.startValue}
        onChange={props.onStartChange}
        firstDayOfWeek={0}
        formatDate={props.formatDate}
        minDate={props.minDate}
        maxDate={props.maxDate} />
      <Arrow style={{width: '40px'}}/>
      <DatePicker
        style={{width: '35%'}}
        textFieldStyle={{width:'90%', fontSize: '13px', paddingLeft: '10px'}}
        container={(isTouchDevice) ? "" : "inline"}
        hintText="End Date"
        value={props.endValue}
        onChange={props.onEndChange}
        firstDayOfWeek={0}
        formatDate={props.formatDate}
        minDate={props.minDate}
        maxDate={props.maxDate} />
      <ResetBtn onClick={props.onResetDates} alt="Reset Dates" />
    </div>
  )
}

export default DateRange;

DateRange.propTypes = {
  reset: PropTypes.func,
  startValue: PropTypes.object,
  endValue: PropTypes.object,
  onStartChange: PropTypes.func,
  onEndChange: PropTypes.func,
  formatDate: PropTypes.func,
  minDate: PropTypes.object,
  maxDate: PropTypes.object
};

DateRange.contextTypes = {
  media: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/scripts/components/lib/formElements/DateRange.js